"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ThemeSpacing = _interopRequireDefault(require("../Theme/ThemeSpacing.js"));

var _UlModule = _interopRequireDefault(require("./Ul.module.scss"));

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * `Ul` abstraction
 */
class Ul extends _react.default.PureComponent {
  /**
   * Render.
   * 
   * @return {ReactNode}
   */
  render() {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("ul", {
      className: `${_UlModule.default.ul} ${this.props.className || ""}`.trim(),
      style: this.styles,
      children: this.props.children
    });
  }
  /**
   * Get our styles.
   * 
   * @return {Object}
   */


  get styles() {
    return {
      "--ul-gap": (0, _ThemeSpacing.default)(this.props.gap),
      "--ul-vertical-align": this.props.verticalAlign
    };
  }

  static propTypes = {
    className: _propTypes.default.string,
    children: _propTypes.default.node,
    gap: _propTypes.default.number,
    verticalAlign: _propTypes.default.string
  };
  static defaultProps = {
    gap: 1,
    verticalAlign: "top"
  };
}

var _default = Ul;
exports.default = _default;